import { MdlDialogReference, MdlSnackbarService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, OnInit, OnDestroy } from '@angular/core';


export const MESSAGE_SERVICE_TOKEN = new InjectionToken('MessageServiceToken');

export class MessageDialogRequest {
    public message: string;
    public isSuccess: boolean;
    public title: string;
    public icon: string;
}

@Component({
    selector: 'message-dialog',
    template: require('./message-dialog.component.html'),
    styles: [require('./message-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MessageDialogComponent  {

    public messageDialogRequest = new MessageDialogRequest();

    constructor(private dialog: MdlDialogReference,
                @Inject(MESSAGE_SERVICE_TOKEN) private readonly messageRequest: MessageDialogRequest) {
                
        this.messageDialogRequest = messageRequest;
    }

    public close() {
        this.dialog.hide(true);
    }

    public handleNgClass() {
        return this.messageDialogRequest.isSuccess ? 'wrapper' : 'wrapper-error';
    }
}